var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.416,
    height: 65.852,
    viewBox: "0 0 14.927 17.423",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.253 17.366C2.055 14.238.043 11.629 0 4.37c0-.146.079-.284.206-.356L7.266.051a.402.402 0 01.394 0l7.06 3.963c.128.072.207.21.207.356-.043 7.26-2.054 9.868-7.253 12.996a.413.413 0 01-.421 0",
    fill: "#85e3ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.316 10.25h.003zm-5.377-.19l2.525 1.445 2.524-1.445V7.13L7.464 5.684 4.939 7.129zm2.525 2.15a.328.328 0 01-.163-.042l-2.853-1.633a.329.329 0 01-.165-.285V6.94c0-.118.063-.226.165-.285l2.853-1.633a.329.329 0 01.325 0l2.852 1.633a.327.327 0 01.166.284v3.311a.328.328 0 01-.166.285l-2.852 1.633a.327.327 0 01-.162.043",
    fill: "#6fbcae"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.207 6.865l-.743-.425-1.87 1.07v2.17l1.335.764z",
    fill: "#fdfeff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.705 11.071l-1.766-1.01V7.13l2.524-1.446.968.554.224-.627-1.029-.589a.327.327 0 00-.326 0L4.45 6.655a.328.328 0 00-.165.284v3.311c0 .118.062.226.165.285l2.032 1.163z",
    fill: "#fdfeff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.349 8.147v2.103c0 .37-.199.712-.52.897L7.977 12.78a1.037 1.037 0 01-1.023.002l-2.855-1.635a1.036 1.036 0 01-.52-.897V9.82H1.356c.925 3.15 2.876 4.889 6.107 6.85 4.348-2.639 6.377-4.875 6.709-10.69z",
    fill: "#6fbcae"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.051 9.51V6.037l6.02-3.307 5.092 2.954h1.024c.017-.367.028-.746.033-1.142L7.464.75.707 4.542C.728 6.536.91 8.151 1.27 9.51z",
    fill: "#fdfeff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlatinum);
export default __webpack_public_path__ + "static/media/icon-platinum.31b52675fdac5e6ff48e3178002b44df.svg";
export { ForwardRef as ReactComponent };